<div id="safety-bi-report"></div>